/*
 * Configurateur « Quelle barrière pour mon escalier ? » - Securidou
 * Calcul 100% côté client (vanilla, aucune dépendance, aucun AJAX).
 * Lit 4 réponses dans le DOM, construit une recommandation d'installation
 * (fixation, nombre de barrières, compatibilité largeur, cas particuliers) et
 * révèle la barrière Securidou quand elle convient (carte rendue en Liquid).
 *
 * Conventions : préfixe CSS sd-tool__, data-attributes pour le pilotage.
 * Garde-fou : jamais de produit fantôme. La carte produit n'apparaît que si la
 * largeur est dans la plage catalogue. Sinon, conseil honnête sans lien.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sd_barriere_v1';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var root = document.querySelector('[data-barriere]');
    if (!root) return;

    var form = root.querySelector('[data-barriere-form]');
    var resultBox = root.querySelector('[data-result]');
    if (!form || !resultBox) return;

    var largeurInput = form.querySelector('[data-largeur]');
    var errorEl = form.querySelector('[data-error]');
    var pool = root.querySelector('[data-product-pool]');
    var resetBtn = root.querySelector('[data-reset]');

    // Plage catalogue (settings de section, défaut = specs réelles barrière Securidou).
    var LARGEUR_MIN = parseInt(root.getAttribute('data-largeur-min'), 10) || 75;
    var LARGEUR_MAX = parseInt(root.getAttribute('data-largeur-max'), 10) || 110;
    var PRODUCT_HANDLE = root.getAttribute('data-product') || '';

    var RADIO_GROUPS = ['emplacement', 'support', 'fixation'];

    /* ---------- Persistance (localStorage) ---------- */
    function saveState() {
      try {
        var state = { largeur: largeurInput ? largeurInput.value : '' };
        RADIO_GROUPS.forEach(function (name) {
          var checked = form.querySelector('input[name="' + name + '"]:checked');
          if (checked) state[name] = checked.value;
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (e) {
        /* stockage indisponible - on ignore silencieusement */
      }
    }

    function restoreState() {
      var raw;
      try {
        raw = localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        return;
      }
      if (!raw) return;
      var state;
      try {
        state = JSON.parse(raw);
      } catch (e) {
        return;
      }
      RADIO_GROUPS.forEach(function (name) {
        if (!state[name]) return;
        var input = form.querySelector('input[name="' + name + '"][value="' + state[name] + '"]');
        if (input) input.checked = true;
      });
      if (state.largeur && largeurInput) largeurInput.value = state.largeur;
    }

    /* ---------- Lecture des réponses ---------- */
    function getRadio(name) {
      var checked = form.querySelector('input[name="' + name + '"]:checked');
      return checked ? checked.value : '';
    }

    function getLargeur() {
      if (!largeurInput) return NaN;
      var v = parseInt(largeurInput.value, 10);
      return isNaN(v) ? NaN : v;
    }

    /* ---------- Progression ---------- */
    function answeredCount() {
      var n = 0;
      RADIO_GROUPS.forEach(function (name) {
        if (getRadio(name)) n += 1;
      });
      if (!isNaN(getLargeur())) n += 1;
      return n;
    }

    function updateProgress() {
      var progressEl = root.querySelector('[data-progress]');
      if (!progressEl) return;
      var total = RADIO_GROUPS.length + 1;
      var answered = answeredCount();
      var pct = Math.round((answered / total) * 100);
      progressEl.style.setProperty('--sd-progress', pct + '%');
      progressEl.setAttribute('aria-valuenow', String(pct));
      var label = progressEl.querySelector('[data-progress-label]');
      if (label) label.textContent = answered + ' / ' + total + ' répondu';
    }

    /* ---------- Moteur de recommandation ---------- */
    function compute() {
      var emplacement = getRadio('emplacement');
      var support = getRadio('support');
      var fixation = getRadio('fixation');
      var largeur = getLargeur();

      var missing = [];
      if (!emplacement) missing.push('emplacement');
      if (!support) missing.push('support');
      if (isNaN(largeur)) missing.push('largeur');
      if (!fixation) missing.push('fixation');
      if (missing.length) return { valid: false, missing: missing };

      var hautConcerne = emplacement === 'haut' || emplacement === 'deux';
      var fixationRequise = hautConcerne ? 'vissee' : 'pression';
      var conflit = fixationRequise === 'vissee' && fixation === 'sans-percage';
      var nombre = emplacement === 'deux' ? 2 : 1;

      var largeurCat;
      if (largeur < LARGEUR_MIN) largeurCat = 'etroite';
      else if (largeur <= LARGEUR_MAX) largeurCat = 'ok';
      else largeurCat = 'large';

      // Produit visible uniquement si la largeur est couverte par le catalogue.
      var produitVisible = largeurCat !== 'etroite';

      return {
        valid: true,
        emplacement: emplacement,
        support: support,
        fixation: fixation,
        largeur: largeur,
        hautConcerne: hautConcerne,
        fixationRequise: fixationRequise,
        conflit: conflit,
        nombre: nombre,
        largeurCat: largeurCat,
        produitVisible: produitVisible
      };
    }

    /* ---------- Libellés ---------- */
    var EMPLACEMENT_LABEL = {
      haut: 'le haut de votre escalier',
      bas: 'le bas de votre escalier',
      deux: 'le haut et le bas de votre escalier',
      porte: 'une porte ou un couloir'
    };

    function synthese(r) {
      var fix = r.fixationRequise === 'vissee'
        ? 'une barrière à <strong>visser</strong>'
        : 'une barrière à <strong>pression</strong> (ou à visser)';
      var nb = r.nombre === 2 ? '<strong>2 barrières</strong>' : '<strong>1 barrière</strong>';
      var larg;
      if (r.largeurCat === 'ok') {
        larg = 'Votre ouverture de ' + r.largeur + ' cm est <strong>compatible</strong> (réglage et extensions inclus, plage '
          + LARGEUR_MIN + ' à ' + LARGEUR_MAX + ' cm).';
      } else if (r.largeurCat === 'large') {
        larg = 'Votre ouverture de ' + r.largeur + ' cm dépasse la plage standard (' + LARGEUR_MIN + ' à '
          + LARGEUR_MAX + ' cm) : prévoyez une <strong>extension supplémentaire</strong>.';
      } else {
        larg = 'Votre ouverture de ' + r.largeur + ' cm est <strong>inférieure à ' + LARGEUR_MIN
          + ' cm</strong> : vérifiez qu\'un modèle s\'adapte à une ouverture aussi étroite.';
      }
      return 'Pour ' + EMPLACEMENT_LABEL[r.emplacement] + ', il vous faut ' + nb + ' ' + fix + '. ' + larg;
    }

    function conseils(r) {
      var list = [];
      list.push('Mesurez votre ouverture au point le plus étroit avant de commander.');
      if (r.fixationRequise === 'vissee') {
        list.push('Fixez la barrière à visser dans un support solide (montant, mur porteur) avec des chevilles adaptées au matériau.');
      } else {
        list.push('Pour la pression, choisissez deux surfaces planes et solides bien en face ; serrez fermement et vérifiez la tension régulièrement.');
      }
      if (r.hautConcerne) {
        list.push("En haut de l'escalier, évitez tout modèle à pression avec barre au sol : cette barre devient un obstacle et la fixation résiste moins bien à une poussée.");
      }
      if (r.support === 'rampe') {
        list.push('Côté rampe ou balustrade, il faut un adaptateur de fixation pour barreaux (vendu par les fabricants de fixation) : sans mur droit, la pose directe n\'est pas fiable.');
      }
      if (r.support === 'tournant') {
        list.push("Sur un escalier tournant ou en colimaçon, sécurisez plutôt l'accès (porte de la pièce) ou faites poser la barrière par un professionnel : la géométrie complique une pose fiable.");
      }
      list.push('Vérifiez le double système de verrouillage et que votre bébé ne peut pas l\'ouvrir seul.');
      return list;
    }

    /* ---------- Rendu ---------- */
    function setText(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }
    function setHtml(sel, html) {
      var el = root.querySelector(sel);
      if (el) el.innerHTML = html;
    }
    function toggle(sel, show) {
      var el = root.querySelector(sel);
      if (el) el.hidden = !show;
    }

    function render(r) {
      // Synthèse principale
      setHtml('[data-synthese]', synthese(r));

      // Alerte sécurité NF EN 1930 (haut concerné)
      toggle('[data-alert-securite]', r.hautConcerne);

      // Conflit perçage (vissée requise mais sans perçage)
      toggle('[data-alert-conflit]', r.conflit);

      // Note support particulier
      var noteSupport = '';
      if (r.support === 'rampe') {
        noteSupport = "Vous avez une rampe ou une balustrade d'un côté : prévoyez un adaptateur de fixation pour barreaux. "
          + 'Securidou ne propose pas encore cet accessoire, mais il est disponible chez les fabricants de fixation.';
      } else if (r.support === 'tournant') {
        noteSupport = 'Escalier tournant ou en colimaçon : c\'est le cas le plus délicat. La solution la plus sûre est souvent '
          + "de sécuriser la porte d'accès à la pièce plutôt que la cage d'escalier elle-même.";
      }
      toggle('[data-note-support]', noteSupport !== '');
      if (noteSupport) setText('[data-note-support-text]', noteSupport);

      // Conseils d'installation
      var ul = root.querySelector('[data-conseils]');
      if (ul) {
        ul.innerHTML = '';
        conseils(r).forEach(function (c) {
          var li = document.createElement('li');
          li.className = 'sd-tool__conseil';
          li.textContent = c;
          ul.appendChild(li);
        });
      }

      // Carte produit (depuis le pool) + quantité + note extension
      var recoWrap = root.querySelector('[data-reco-produit]');
      var recoHost = root.querySelector('[data-reco-card]');
      if (recoWrap && recoHost && pool) {
        recoHost.innerHTML = '';
        if (r.produitVisible && PRODUCT_HANDLE) {
          var card = pool.querySelector('[data-handle="' + cssEscape(PRODUCT_HANDLE) + '"]');
          if (card) {
            var clone = card.cloneNode(true);
            clone.hidden = false;
            recoHost.appendChild(clone);
            recoWrap.hidden = false;
          } else {
            recoWrap.hidden = true;
          }
        } else {
          recoWrap.hidden = true;
        }
      }
      // Quantité + note extension
      var qtyEl = root.querySelector('[data-reco-qty]');
      if (qtyEl) {
        var qtyTxt = r.nombre === 2
          ? 'Quantité conseillée : 2 barrières (une en haut, une en bas).'
          : 'Quantité conseillée : 1 barrière.';
        if (r.largeurCat === 'large') qtyTxt += ' Pensez à l\'extension au-delà de ' + LARGEUR_MAX + ' cm.';
        qtyEl.textContent = qtyTxt;
      }

      // Cas ouverture trop étroite : message dédié à la place du produit
      toggle('[data-note-etroite]', r.largeurCat === 'etroite');

      resultBox.hidden = false;

      // dataLayer (GA4/GTM) - pas de PII
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'tool_complete',
          tool: 'barriere-escalier',
          emplacement: r.emplacement,
          support: r.support,
          fixation: r.fixationRequise,
          nombre: r.nombre,
          largeur_cat: r.largeurCat
        });
      } catch (e) {
        /* noop */
      }

      // Focus accessible + scroll
      if (resultBox.setAttribute) resultBox.setAttribute('tabindex', '-1');
      resultBox.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      try {
        resultBox.focus({ preventScroll: true });
      } catch (e) {
        /* noop */
      }
    }

    function showError(missing) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = 'Merci de répondre aux ' + missing.length
        + ' question(s) restante(s) pour obtenir votre recommandation.';
      // Cible la première question manquante
      var firstName = missing[0];
      var target = firstName === 'largeur'
        ? largeurInput
        : form.querySelector('input[name="' + firstName + '"]');
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
      }
    }

    /* ---------- Utilitaires ---------- */
    function cssEscape(str) {
      if (window.CSS && window.CSS.escape) return window.CSS.escape(str);
      return String(str).replace(/["\\\]]/g, '\\$&');
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* ---------- Événements ---------- */
    form.addEventListener('change', function () {
      updateProgress();
      saveState();
      if (errorEl && !errorEl.hidden) errorEl.hidden = true;
    });

    if (largeurInput) {
      largeurInput.addEventListener('input', function () {
        updateProgress();
        saveState();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = compute();
      if (!r.valid) {
        showError(r.missing);
        return;
      }
      if (errorEl) errorEl.hidden = true;
      render(r);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (err) {
          /* noop */
        }
        form.reset();
        resultBox.hidden = true;
        if (errorEl) errorEl.hidden = true;
        updateProgress();
        form.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* ---------- Init ---------- */
    restoreState();
    updateProgress();
  });
})();
